module.exports = __webpack_public_path__ + "static/media/leader_notes.b50cb6d7.pdf";